import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RegionSelector from '../../FormElements/regionSelector/RegionSelector';
import ChapterSelector from '../../FormElements/chapterSelector/ChapterSelector';
import CaseNumberSelector from '../../FormElements/caseSelector/CaseNumberSelector';
import CaseTitleSelector from '../../FormElements/caseSelector/CaseTitleSelector';
import PartySelector from '../../FormElements/partySelector/PartySelector';
import SSN4 from '../../FormElements/ssnSelectors/SSN4';
import SSNTin from '../../FormElements/ssnSelectors/SSNTin';

import Collapsible from '../../../common/Collapsible';
import AlertError from '../../../common/AlertError';
import DateFilter from '../../FormElements/dateFilter/DateFilter';
import ActionButtons from '../../FormElements/actionButtons/ActionButtons';
import { receiveError } from '../../../../redux/actions/pacerSearch';

import validateLocalCourtsInputs from './validateLocalCourtsInputs';
import validations from '../../validations';
import Tip from '../../FormElements/Tip/Tip';

import * as errorConstants from '../../../../constants/errorConstants';


class BankruptcySearchForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateCollapsed: true
    }
  }

  dateCollapseChanged = (collapsible) => {
    this.setState({ dateCollapsed: collapsible.isCollapsed })
  }

  componentDidMount = () => {
    if (this.props.immediateSearch) {
      this.searchClickHandler()
    }
  }

  validateInputs(filtersMap) {
    const filters = filtersMap.toJS()
    if (!client_code_is_valid()) return { messages: ["Please set a valid client code first."] };

    const messages = [];
    const fields = [];

    if (filters.party_name && !validations.PARTY_NAME_CASE_TITLE(filters.party_name)) {
      messages.push('Invalid party name.')
      fields.push('party_name')
    }

    if (filters.case_title && !validations.PARTY_NAME_CASE_TITLE(filters.case_title)) {
      messages.push('Invalid case title.')
      fields.push('case_title')
    }

    if (filters.case_no && !validations.CASE_NUMBER(filters.case_no)) {
      messages.push('Invalid case number format.')
      fields.push('case_no')
    }

    if (filters.ssn4) {
      if (!validations.SSN4(filters.ssn4)) {
        messages.push('Invalid last 4 digits of SSN/TIN.')
        fields.push('ssn4')
      }
      if (_.isEmpty(filters.party_name)) {
        messages.push('Party Name must be included when searching by 4 digit SSN.')
        fields.push('party_name')
      }
    }

    if (filters.ssntin && !validations.SSN_OR_TIN(filters.ssntin)) {
      messages.push('Invalid SSN/TIN.')
      fields.push('ssntin')
    }

    // return any errors found so far
    if (!_.isEmpty(messages)) return { messages, fields };


    // if no other errors to report, check if we have any fields filled in at all
    const desired_fields = [
      'chapter', 'case_no', 'case_title', 'ssntin', 'party_name',
      'filed_from', 'filed_to', 'closed_from', 'closed_to',
      'dismissed_from', 'dismissed_to', 'discharged_from', 'discharged_to'
    ];

    const fieldNotEmpty = (fieldName) => !!filters[fieldName];
    if (!desired_fields.find(fieldNotEmpty)) {
      return {
        messages: [
          "Please enter at least one search parameter:",
          "- Chapter",
          "- Case number",
          "- Case title",
          "- Party name",
          "- SSN/TIN",
          "- Date Field",
        ],
        fields: desired_fields
      }
    }
  }

  searchClickHandler = () => {
    const validationErrors = this.validateInputs(this.props.filters)
    if (validationErrors) {
      this.props.dispatch(receiveError(errorConstants.VALIDATION_ERROR, validationErrors))
    } else {
      this.props.actions.searchBankruptcies(this.props.filters)
    }
  };

  searchBankruptciesLocalClickHandler = () => {
    const validationErrors = validateLocalCourtsInputs(this.props.filters);
    if (validationErrors) {
      return this.props.dispatch(receiveError('VALIDATION_ERROR', validationErrors))
    }

    this.props.actions.searchBankruptciesLocal(this.props.filters);
  };

  render() {
    const formElemProps = Object.assign({}, { ...this.props }, { onChange: this.props.updateFilter })

    const localValidationErrors = validateLocalCourtsInputs(this.props.filters);
    const isLocalSearchAllowed = !localValidationErrors;

    return (
      <div className="search-form-container">
        <Tip title="Using Local Court Search">
          <p>1. Select a single bankruptcy court (not a general area or circuit court).</p>
          <p>2. Enter at least one of the following: case number, or party name, SSN, or date filter (you cannot search by
            case title).</p>
          <p>3. Local Court Search, (unlike Pacer Search), is NOT subject to the 30-page limit so be careful
            to select criteria that is not too broad or general.</p>
        </Tip>

        <fieldset className="ir-search-double">
          <RegionSelector {...formElemProps} />
          <ChapterSelector {...formElemProps} />
        </fieldset>

        <CaseNumberSelector {...formElemProps} />
        <CaseTitleSelector {...formElemProps} />

        <Collapsible title="Date Filters" onChange={this.dateCollapseChanged}>
          <DateFilter {...formElemProps} name="filed"/>
          <DateFilter {...formElemProps} name="closed"/>
          <DateFilter {...formElemProps} name="dismissed"/>
          <DateFilter {...formElemProps} name="discharged"/>
        </Collapsible>

        <PartySelector
          {...formElemProps}
          tooltipClassName={`party-tooltip${!this.state.dateCollapsed ? ' top-70' : ''}`}
        />

        <SSN4 {...formElemProps} />
        <SSNTin {...formElemProps}/>

        <ActionButtons
          {...formElemProps}
          searchType={this.props.searchType}
          searchClickHandler={this.searchClickHandler}
          isLocalSearchAllowed={isLocalSearchAllowed}
          localSearchClickHandler={this.searchBankruptciesLocalClickHandler}
        />
        {isLocalSearchAllowed && (
          <div className="warning">
            By pressing on the "Local Court Search" button you will be billed for the total
            number of pages (this report is not subject to the 30-page limit on PACER charges).
          </div>
        )}
        <br/>

        <AlertError/>
      </div>
    )
  }
}

BankruptcySearchForm.propTypes = {
  searchType: PropTypes.string,
};

BankruptcySearchForm.defaultProps = {
  searchType: 'bottom'
};


const mapStateToProps = state => ({ immediateSearch: state.get('immediateSearch') })

export default connect(mapStateToProps)(BankruptcySearchForm)



/** WEBPACK FOOTER **
 ** ./src/components/search/forms/bankruptcySearchForm/BankruptcySearchForm.js
 **/